import React from "react"
import PropTypes from "prop-types"
import Header from "./header"

const Layout = ({children, className }) => {
  return (
    <>
      <Header />
      <main className={`${className} font-body fixed top-0 left-0 z-10 w-screen h-screen`}>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
